import LoaderBalls from 'components/LoaderBalls'
import MeetingSchedulerCard from 'components/Message/messageTypes/meeting/scheduler/meetingSchedulerCard'
import React from 'react'

import './style.css'

export default ()=>{
  return <MeetingSchedulerCard loadingFrame={true}>
    <LoaderBalls />
  </MeetingSchedulerCard>
}
